import type { ButtonConfig } from '../declare'
import * as Header from './header'
import { $consts } from 'src/plugins'

/**
 * 列表表单表格头部按钮
 * @param props 
 * @returns 
 */
const HeaderButton = (props: { config: ButtonConfig }) => {
  const { BTN_TYPE } = props.config
  switch (BTN_TYPE) {
    // 批量新增保存按钮（非后端配置，由前端渲染的按钮）
    case $consts['TABLE/BTN_TYPE_BATCH_SAVE']:
      return <Header.BatchSaveBtn config={props.config} />
    // 自定义表单按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_PAGE']:
      return <Header.CustomModalBtn config={props.config} />
    // 保存按钮
    case $consts['TABLE/BTN_TYPE_SAVE']:
      return <Header.SaveBtn config={props.config} />
    // 刷新按钮
    case $consts['TABLE/BTN_TYPE_REFRESH']:
      return <Header.RefreshBtn config={props.config} />
    // 新增按钮
    case $consts['TABLE/BTN_TYPE_ADD']:
      return <Header.AddBtn config={props.config} />
    // 批量新增按钮
    case $consts['TABLE/BTN_TYPE_BATCH_ADD']:
      return <Header.BatchAddBtn config={props.config} />
    // 编辑按钮
    case $consts['TABLE/BTN_TYPE_EDIT_PAGE']:
      return <Header.EditModalBtn config={props.config} />
    // 自定义事件按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_EVT']:
      return <Header.CustomEvtBtn config={props.config} />
    // 自定义渲染按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_BTN']:
      return <Header.CustomRenderBtn config={props.config} />
    // 删除按钮
    case $consts['TABLE/BTN_TYPE_DELETE']:
      return <Header.DeleteConfirmBtn config={props.config} />
    // 导出
    case $consts['TABLE/BTN_TYPE_EXPORT']:
      return <Header.TableExport config={props.config} />
    // 导入
    case $consts['TABLE/BTN_TYPE_IMPORT']:
      return <Header.ExcelImport config={props.config} />
    // 自定义导入
    case $consts['TABLE/BTN_TYPE_CUSTOM_IMPORT']:
      return <Header.CustomImport config={props.config} />
    default:
      return <div />
  }
}

export default HeaderButton